import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import {
  fetchContextsInitAction,
  getContextSuccessAction,
  updateContextFiltersAction,
  updateSelectedContextAction,
} from '../../../../../actions/instances/context';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import EmptyView from '../../../../molecules/EmptyView/EmptyView';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import ContextsTypeSelector from '../../../../atoms/ContextsTypeSelector/ContextTypeSelector';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import ListItem from '../../../../molecules/ListItem/ListItem';
import Icon from '../../../../atoms/Icon/Icon';
import './ListContexts.scss';

const ListContexts = () => {
  const {
    isLoadingContexts,
    didLoadContexts,
    contexts,
    filters,
  } = useSelector(state => state.contexts);
  const isFiltersDirty = filters.dynasties.length > 0
    || filters.cities.length > 0
    || filters.tags.length > 0;
  const dispatch = useDispatch();
  const history = useHistory();
  if (!didLoadContexts && !isLoadingContexts) {
    dispatch(fetchContextsInitAction());
  }
  if (isLoadingContexts) {
    return <FullPageLoader />;
  }
  return (
    <>
      {
        contexts.length === 0 && !isFiltersDirty
          ? (
            <EmptyView
              message="Looks like there's no building contexts here yet."
              action={() => {
                history.push('/instances/building-contexts/create');
              }}
            />
          ) : (
            <div className="components-page-content">
              <div className="row actions-container">
                <h4 className="mb-4">Contexts Filters</h4>
                <div className="filters">
                  <div className="actions">
                    <div className="filter-item">
                      <DynastySelector
                        isMulti
                        onChanged={(val) => {
                          filters.dynasties = val.map(dynasty => dynasty.value);
                          dispatch(updateContextFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CitySelector
                        isMulti
                        onChanged={(val) => {
                          filters.cities = val.map(city => city.value);
                          dispatch(updateContextFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <TagsSelector
                        isMulti
                        onChanged={(val) => {
                          filters.tags = val.map(tag => tag.value);
                          dispatch(updateContextFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <ContextsTypeSelector
                        isMulti
                        onChanged={(val) => {
                          filters.types = val.map(tag => tag.value);
                          dispatch(updateContextFiltersAction(filters));
                        }}
                      />
                    </div>
                  </div>
                  <Button variant="default" onClick={() => history.push('/instances/building-contexts/create')}>
                    <Icon icon="plus" color="#000" />
                  </Button>
                </div>
              </div>
              <div className="row components-list">
                <div className="col-md-9">
                  {contexts && contexts.length > 0 ? (
                    <ListBase>
                      {contexts.map(context => (
                        <ListItem
                          imgSrc={context.images.length > 0 ? context.images[0].url : '/images/default.jpg'}
                          name={context.name}
                          code={context.code}
                          dynasty={context.dynasty.name}
                          location={`${context.city.name} [${context.city.country.code}-${context.city.code}]`}
                          creationDate={context.created_at}
                          onViewClicked={() => {
                            dispatch(updateSelectedContextAction(context));
                            history.push('/instances/building-contexts/view');
                          }}
                          onEditClicked={() => {
                            dispatch(getContextSuccessAction(context));
                            history.push('/instances/building-contexts/create');
                          }}
                          inReview={context.in_review}
                        />
                      ))}
                    </ListBase>
                  ) : (
                    <EmptyView
                      message="No contexts matches these filters"
                      action={() => history.push('/instances/building-contexts/create')}
                    />
                  )}
                </div>
                <div className="col-md-3 p-0">
                  <Sidebar />
                </div>
              </div>
            </div>
          )
      }
    </>
  );
};

export default ListContexts;
